module.exports = __webpack_public_path__ + "static/media/kingcake.e0895196.jpeg";